import {FlowType} from "./flowType";
import {EntityPaymentTypes} from "./payment";
import {CurrencyType, TFile} from "@brg/api";
import {DeliveryRequest} from "./DeliveryRequest";

export interface RejectErrorType {
    message: string
    args: any
}

export enum PointerElementTypes {
    alphabet = 'alphabet',
    common = 'common',
}

export interface PaginationProps {
    count: number
    limit: number
    offset: number
    page: number
    pages: number
}


export interface Product extends Partial<ProductRequest> {
    id: string,
    name: string,
    type: EntityPaymentTypes,
    summary: {
        [key: string]: string
    }
    preview: TFile[] | "calendar",
    cardInfo?: any
}

export interface ProductRequest {
    productId: string,
    paymentEntityType: EntityPaymentTypes,
    productInfo: {
        preview: TFile[] | "calendar"
        name: string,
        price?: number | null,
        summary: {
            [key: string]: string
        }
    }
}

export interface ImmediatePurchaseProps extends ProductRequest {
    currencyType: CurrencyType
    contact?: any
    flowType?: FlowType           //текущий flowType, чтобы потом можно было вызвать его же в других местах
    countryId?: string            //это на случай если покупаем страну валютой другой страны             
}

export interface CurrencyPart {
    amount: number | null
    currencyType: CurrencyType
}

// простая валюта - исспользуется один тип валюты для покупки
export interface SimpleCurrency extends CurrencyPart {
    countryId?: string | null
    currencyName?: string
    cardsPrice?: number | null
    templatePrice?:number | null
}

// сложная (композтная/сплит) валюта - для покпки используется несколько валют одновременно
export interface CompositeCurrency {
    parts: CurrencyPart[]
}

export type PaymentCurrency = SimpleCurrency | CompositeCurrency


// валюта пользователя - есть дополнительные поля
export interface UserPaymentCurrency extends CurrencyPart {
    id: string,
    countryId?: string | null,
    // последняя операция по валюте
    lastDelta: number,
    rate: any
}

export enum TariffTypes {
    low = 1,
    middle = 2,
    high = 3,
    custom = 4,
}

export interface AvailableTariff {
    authorK: number
    creatingPrice: number,
    currencyType: CurrencyType,
    doubleProfitSequenceLength?: number
    type: TariffTypes,
    userPrice: number,
}

export interface OptionProps {
    value: string
    label: string
} 

export interface ProductFields {
    productPrice?: number
    productPriceWithCard?: number
    productAmount?: number 
    deliveryMethod?: OptionProps[] 
    paymentMethod?: OptionProps[] 
    productInfo?: any
    paymentType?: number
    priceWithCard?: number
    userPrice?: number
    realProductId?: number
}

export interface OrderInitial {
    bookCard: any | null
    bookCardT: number
    activeTariff: AvailableTariff | null
    availableTariffs: AvailableTariff[]
    paymentCurrencies: PaymentCurrency[] 
    currenciesloading: boolean
    currencyType: CurrencyType
    delivery: DeliveryRequest;
    deliveryTypes: OptionProps[] | null
    error: any
    immediatePurchaseProps?: ImmediatePurchaseProps | any | null //вариант создания ордера с одновременной оплатой
    isModerBuying?: boolean
    loading: boolean
    orderId: string | null;
    price: number
    products: Product[]
    productFields: ProductFields | null
    tariffsLoading: boolean
    flowStep: number,
    flowSize: number
    flowType: FlowType | null,
    totalPrices: any | null,
}

export interface initOrderRequest extends ProductRequest {
    currencyType: CurrencyType
    orderId?: string
    preventGetCurrencies?: boolean
    options?: any
}
import {FlowType} from "./flowType";
import {EntityPaymentTypes} from "./payment";
import {CurrencyType, TFile} from "@brg/api";
import {DeliveryRequest} from "./DeliveryRequest";

export interface RejectErrorType {
    message: string
    args: any
}

export enum PointerElementTypes {
    alphabet = 'alphabet',
    common = 'common',
}

export interface PaginationProps {
    count: number
    limit: number
    offset: number
    page: number
    pages: number
}


export interface Product extends Partial<ProductRequest> {
    id: string,
    name: string,
    type: EntityPaymentTypes,
    summary: {
        [key: string]: string
    }
    preview: TFile[] | "calendar",
    cardInfo?: any
}

export interface ProductRequest {
    productId: string,
    paymentEntityType: EntityPaymentTypes,
    productInfo: {
        preview: TFile[] | "calendar"
        name: string,
        price?: number | null,
        summary: {
            [key: string]: string
        }
    }
}

export interface ImmediatePurchaseProps extends ProductRequest {
    currencyType: CurrencyType
    contact?: any
    flowType?: FlowType           //текущий flowType, чтобы потом можно было вызвать его же в других местах
    countryId?: string            //это на случай если покупаем страну валютой другой страны             
}

export interface CurrencyPart {
    amount: number | null
    currencyType: CurrencyType
}

// простая валюта - исспользуется один тип валюты для покупки
export interface SimpleCurrency extends CurrencyPart {
    countryId?: string | null
    currencyName?: string
    cardsPrice?: number | null
    templatePrice?:number | null
}

// сложная (композтная/сплит) валюта - для покпки используется несколько валют одновременно
export interface CompositeCurrency {
    parts: CurrencyPart[]
}

export type PaymentCurrency = SimpleCurrency | CompositeCurrency


// валюта пользователя - есть дополнительные поля
export interface UserPaymentCurrency extends CurrencyPart {
    id: string,
    countryId?: string | null,
    // последняя операция по валюте
    lastDelta: number,
    rate: any
}

export enum TariffTypes {
    low = 1,
    middle = 2,
    high = 3,
    custom = 4,
}

export interface AvailableTariff {
    authorK: number
    creatingPrice: number,
    currencyType: CurrencyType,
    doubleProfitSequenceLength?: number
    type: TariffTypes,
    userPrice: number,
}

export interface OptionProps {
    value: string
    label: string
} 

export interface ProductFields {
    productPrice?: number
    productPriceWithCard?: number
    productAmount?: number 
    deliveryMethod?: OptionProps[] 
    paymentMethod?: OptionProps[] 
    productInfo?: any
    paymentType?: number
    priceWithCard?: number
    userPrice?: number
    realProductId?: number
}

export interface OrderInitial {
    bookCard: any | null
    bookCardT: number
    activeTariff: AvailableTariff | null
    availableTariffs: AvailableTariff[]
    paymentCurrencies: PaymentCurrency[] 
    currenciesloading: boolean
    currencyType: CurrencyType
    delivery: DeliveryRequest;
    deliveryTypes: OptionProps[] | null
    error: any
    immediatePurchaseProps?: ImmediatePurchaseProps | any | null //вариант создания ордера с одновременной оплатой
    isModerBuying?: boolean
    loading: boolean
    orderId: string | null;
    price: number
    products: Product[]
    productFields: ProductFields | null
    tariffsLoading: boolean
    flowStep: number,
    flowSize: number
    flowType: FlowType | null,
    totalPrices: any | null,
}

export interface initOrderRequest extends ProductRequest {
    currencyType: CurrencyType
    orderId?: string
    preventGetCurrencies?: boolean
    options?: any
}
